/* eslint-disable import/prefer-default-export */
const CUTOFF_TIME_MAX_DAYS_BEFORE = 6;

export { CUTOFF_TIME_MAX_DAYS_BEFORE };
